window.initializeCascadeFilter = function (
  sectionId,
  yearUrl,
  makeUrl,
  modelUrl
) {
  // Load year options
  const loadYearOptions = (sectionId, yearUrl) => {
    fetch(yearUrl)
      .then((response) => response.json())
      .then((data) => {
        const yearSelect = document.getElementById(`year-select-${sectionId}`);
        data.search_year.forEach((year) => {
          const option = document.createElement("option");
          option.value = year.value;
          option.textContent = year.text;
          yearSelect.appendChild(option);
        });
      })
      .catch((error) => console.error("Error loading year JSON:", error));
  };
  
  loadYearOptions(sectionId, yearUrl);

  // Add event listener for year selection
  document
    .getElementById(`year-select-${sectionId}`)
    .addEventListener("change", function () {
      const selectedYear = this.value;
      const makeSelect = document.getElementById(`make-select-${sectionId}`);
      const modelSelect = document.getElementById(`model-select-${sectionId}`);
      makeSelect.innerHTML = '<option value="">Select Make</option>'; // Reset make options
      modelSelect.innerHTML = '<option value="">Select Model</option>'; // Reset model options
      makeSelect.disabled = true;
      modelSelect.disabled = true;

      if (selectedYear) {
        // Load make options based on selected year
        fetch(makeUrl)
          .then((response) => response.json())
          .then((data) => {
            if (data[selectedYear]) {
              data[selectedYear].forEach((make) => {
                const option = document.createElement("option");
                option.value = make.value;
                option.textContent = make.text;
                makeSelect.appendChild(option);
              });
              makeSelect.disabled = false;
            }
          })
          .catch((error) => console.error("Error loading make JSON:", error));
      }
    });

  // Add event listener for make selection
  document
    .getElementById(`make-select-${sectionId}`)
    .addEventListener("change", function () {
      const selectedYear = document.getElementById(
        `year-select-${sectionId}`
      ).value;
      const selectedMake = this.value;
      const modelSelect = document.getElementById(`model-select-${sectionId}`);
      modelSelect.innerHTML = '<option value="">Select Model</option>'; // Reset model options
      modelSelect.disabled = true;

      if (selectedYear && selectedMake) {
        // Load model options based on selected year and make
        fetch(modelUrl)
          .then((response) => response.json())
          .then((data) => {
            if (data[selectedYear] && data[selectedYear][selectedMake]) {
              data[selectedYear][selectedMake].forEach((model) => {
                const option = document.createElement("option");
                option.value = model.value;
                option.textContent = model.text;
                modelSelect.appendChild(option);
              });
              modelSelect.disabled = false;
            }
          })
          .catch((error) => console.error("Error loading model JSON:", error));
      }
    });

  // Add event listener for reset button
  document
    .getElementById(`reset-button-${sectionId}`)
    .addEventListener("click", function () {
      const yearSelect = document.getElementById(`year-select-${sectionId}`);
      const makeSelect = document.getElementById(`make-select-${sectionId}`);
      const modelSelect = document.getElementById(`model-select-${sectionId}`);

      yearSelect.value = "";
      makeSelect.innerHTML = '<option value="">Select Make</option>';
      modelSelect.innerHTML = '<option value="">Select Model</option>';
      makeSelect.disabled = true;
      modelSelect.disabled = true;
    });

  document
    .getElementById(`search-button-${sectionId}`)
    .addEventListener("click", function () {
      const yearSelect = document.getElementById(`year-select-${sectionId}`);
      const makeSelect = document.getElementById(`make-select-${sectionId}`);
      const modelSelect = document.getElementById(`model-select-${sectionId}`);

      // 获取选中项的文本内容
      const year = yearSelect.options[yearSelect.selectedIndex].textContent;
      const make = makeSelect.options[makeSelect.selectedIndex].textContent;
      const model = modelSelect.options[modelSelect.selectedIndex].textContent;

      // 检查是否选择了有效的选项
      if (
        year !== "Select Year" &&
        make !== "Select Make" &&
        model !== "Select Model"
      ) {
        // 构造包含标签的 URL
        const tags = [make, model].filter(Boolean).join(" "); // 过滤空值并用空格连接
        const searchQuery = `${year} ${make} ${model}`.trim(); // 拼接成标题搜索字符串并去除首尾空格
        //const url = `/search?q=${encodeURIComponent(searchQuery)}`; // 构建搜索链接
        const url = `/collections/car-cover-custom?year=${encodeURIComponent(year)}&make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}`; 
        window.location.href = url; // 激活跳转
      } else {
        showToast("Please select a year, make, and model.");
      }
    });

  function showToast(message) {
    // 创建一个 div 元素
    const toast = document.createElement("div");

    // 设置样式
    toast.style.position = "fixed";
    toast.style.top = "50%";
    toast.style.left = "50%";
    toast.style.transform = "translate(-50%, -50%)";
    toast.style.backgroundColor = "#333";
    toast.style.color = "#fff";
    toast.style.padding = "10px 20px";
    toast.style.borderRadius = "5px";
    toast.style.boxShadow = "0 0 10px rgba(0, 0, 0, 0.1)";
    toast.style.zIndex = "1000";
    toast.style.opacity = "0";
    toast.style.transition = "opacity 0.5s";

    // 设置内容
    toast.textContent = message;

    // 将 toast 添加到文档中
    document.body.appendChild(toast);

    // 显示 toast
    setTimeout(() => {
      toast.style.opacity = "1";
    }, 100);

    // 在 3 秒后移除 toast
    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => {
        document.body.removeChild(toast);
      }, 500);
    }, 3000);
  }
};
